import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import type { VersioningScheduleSourceRow } from "../types/mediaVersionUpdateAlert";

export function useVersioningScheduleColumns(): ColumnDef<VersioningScheduleSourceRow>[] {
    return [
        {
            id: "select",
            header: ({ table }) => (
                <Checkbox
                    checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                    onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                    aria-label="Select all"
                />
            ),
            cell: ({ row }) => (
                <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(v) => row.toggleSelected(!!v)}
                    aria-label="Select row"
                    onClick={(e) => e.stopPropagation()}
                />
            ),
            size: 50,
            minSize: 50,
            maxSize: 50,
            enableSorting: false,
            enableResizing: false,
        },
        { accessorKey: "channel", header: "매체명" },
        { accessorKey: "url", header: "URL" },
        { accessorKey: "selector", header: "Selector" },
    ];
}